"use strict";
// DO NOT EDIT THIS FILE, EDIT THE GULP TASK SETTINGS INSTEAD WHICH GENERATES THIS FILE

angular.module("prepApp", ["ngRoute","ngResource","ngCookies","http-auth-interceptor","ngTable","ui.select","ngSanitize","moment-picker","mwl.calendar","ui.bootstrap"])
.constant("TASK_TYPE", [{"id":"B","title":"vorher"},{"id":"A","title":"nach"}])
.constant("CONFIG", {"authURL":"https://api.dsv-sportentwicklung.de/api-token-auth/","backendURL":"https://api.dsv-sportentwicklung.de/","apiURL":"https://api.dsv-sportentwicklung.de/api/prep/","imagePath":"./images"});
